import React from 'react'

import PropTypes from 'prop-types'

import {
  DEFAULT_SITE_ID,
  DEFAULT_PRODUCT,
  DEFAULT_SITE_NAME,
  UNKNOWN_SITE,
} from 'utils/productHelpers'

import { Container, Text } from './component.styles'

const SchoolOption = ({ siteId, product, siteName }) => {
  const isUnknownSite =
    siteId === DEFAULT_SITE_ID &&
    product === DEFAULT_PRODUCT &&
    siteName === DEFAULT_SITE_NAME
  const content = isUnknownSite ? (
    <span>{UNKNOWN_SITE}</span>
  ) : (
    <span>
      <span>{siteName}</span>
    </span>
  )

  return (
    <Container>
      <Text>{content}</Text>
    </Container>
  )
}

SchoolOption.propTypes = {
  product: PropTypes.string,
  siteId: PropTypes.string,
  siteName: PropTypes.string,
}

SchoolOption.defaultProps = {
  siteId: DEFAULT_SITE_ID,
  product: DEFAULT_PRODUCT,
  siteName: DEFAULT_SITE_NAME,
}

export default SchoolOption
